import { defineStore } from 'pinia';
import {
  type userType,
  store,
  router,
  resetRouter,
  routerArrays,
} from '../utils';
import {
  getUserInfo,
  ISafeUser,
  SignInBody,
  userLogin,
  userLogout,
  UserRole,
} from '@/api/user';
import { useMultiTagsStoreHook } from './multiTags';
import { setToken, removeToken } from '@/utils/auth';
import { intersection } from 'lodash-es';

export const useUserStore = defineStore('pure-user', {
  state: (): userType => ({
    id: 0,
    // 头像
    avatar: 'https://avatars.githubusercontent.com/u/4476132',
    // 用户名
    username: '',
    // 昵称
    nickname: '',
    // 展位号
    boothCode: '',
    // 公司英文名
    companyNameEn: '',
    // 展商类型
    exhibitorType: '',
    // 页面级别权限
    roles: [],
    // 按钮级别权限
    permissions: [],
    // 是否勾选了登录页的免登录
    isRemembered: false,
    // 登录页的免登录存储几天，默认7天
    loginDay: 7,
  }),
  getters: {
    isAdmin: state =>
      intersection(state.roles, [UserRole.SuperAdmin, UserRole.Admin]).length >
      0,
  },
  actions: {
    setUser(user: ISafeUser) {
      this.id = user.id;
      this.avatar =
        'https://image.cbmexpo.com/Chat25/7b9929f1-d5ca-40a7-89ee-f36e7d257f40.png';
      this.username = user.name;
      this.nickname = user.name;
      this.boothCode = user.boothCode;
      this.companyNameEn = user.companyNameEn;
      this.exhibitorType = user.exhibitorType || '';
      this.roles = user.roles;
    },
    /** 登入 */
    async loginByUsername(data: SignInBody) {
      const token = await userLogin(data);
      setToken(token);
      const { data: user } = await getUserInfo();
      this.setUser(user);
    },
    /**
     * 免密登录
     */
    async loginByToken(token: string) {
      setToken(token);
      const { data: user } = await getUserInfo();
      this.setUser(user);
    },
    clearUser() {
      this.id = 0;
      this.avatar = '';
      this.username = '';
      this.nickname = '';
      this.boothCode = '';
      this.companyNameEn = '';
      this.exhibitorType = '';
      this.roles = [];
      this.permissions = [];
    },
    /** 前端登出 */
    logOut() {
      this.clearUser();
      removeToken();
      useMultiTagsStoreHook().handleTags('equal', [...routerArrays]);
      resetRouter();
      userLogout();
      router.push('/login');
    },
  },
});

export function useUserStoreHook() {
  return useUserStore(store);
}
